<template>
  <div class="new widget">
    <Search @search="search"></Search>
    <div class="table-wrapper">
      <table class="table list-table">
        <tr>
          <th style="width: 120px;">序号</th>
          <th>学名</th>
          <th>中文名</th>
          <th>英文名</th>
          <th>分类</th>
        </tr>
        <tr v-for="(item,index) in list" :key="index" v-on:click="goDetail(item.id)">
          <td>{{item.id}}</td>
          <td>{{item.name}}</td>
          <td>{{item.chinese_name}}</td>
          <td>{{item.englist_name}}</td>
          <td>{{item.category}}</td>
        </tr>
      </table>

      <div style="margin-top:10px">
        <v-pagination :total="total" :page-size="10" @page-change="pageChange"></v-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import 'vue-easytable/libs/themes-base/index.css'

  import {VPagination} from 'vue-easytable'
  import Search from '@/components/base/search/search.vue'
  import './new.scss'
  export default {
    name: 'New',
    components: {
      Search,VPagination
    },
    data() {
        return {
            list: [],
            page:1,
            keyword:"",
            total:0
        }
    },
    created () {
      this.search();
    },
    methods: {
      async search(keyword){
          if (keyword) {
              this.page = 1;
              this.keyword = keyword
          }
          let params = {
              page: this.page
          };
          
          if (this.keyword.length>0) {
              params.keyword = this.keyword
          }
          
          let res = await this.$axios.get('/list',{params:params});
          console.log(res);
          
          if (res.data.status == 0) {
          } else {
              this.list = res.data.rows;
              this.total = res.data.count;

          }
            
        },
        pageChange(pageIndex){
            this.page = pageIndex;
            this.search();
        },
        goDetail(id){
          this.$router.push({ path: 'detail', query: { id: id }})
           
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/new/new.vue